import React from 'react';
import { Alert } from 'react-bootstrap';

import { withTranslation, Trans } from 'react-i18next';

class JoinFormSubmitSuccess extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <Alert variant='primary'>
        <Alert.Heading>{t('joinform.success_header')}</Alert.Heading>
        <Trans i18nKey='joinform.success_body'>
        <p>
          We have received your message, amazing human being! There's just one more step to complete to get
          you on the list: We sent you an email message with a link. Please click that link to verify your
          request.
        </p>
        <p>That can take a while. You can twiddle your thumbs in the meantime. If our message hasn't arrived after a good deal of thumb-twiddling, <Alert.Link href="mailto:support@nutrfy.com">please contact us</Alert.Link> so we can sort this out.</p>
        </Trans>
      </Alert>
    )
  }
}

export default withTranslation()(JoinFormSubmitSuccess);